// 마스터 세번관리 — 순수 엑셀(AoA) 빌더. BulkClassifyPanel의 SheetJS 다운로드 관례를 미러링.
export function masterRowsToAoa(items) {
  const header = ["상품명", "성분", "공급자", "세번", "확정일", "저장자"];
  const rows = (items || []).map((r) => [
    r.productName || "",
    r.composition || "",
    r.supplier || "",
    r.hsk || "",
    r.confirmedAt ? String(r.confirmedAt).slice(0, 10) : "",
    r.userId || "",
  ]);
  return [header, ...rows];
}
